<div class="outer-chart-container">
	<div class="inner-chart-container">
		<canvas baseChart [type]="'line'" [data]="chartData" [options]="lineChartOptions" [plugins]="[noDataPlugin]">
		</canvas>
	</div>
</div>
